import { uniqBy } from '@seiue/util'
import { RouteNode, ModalRouteNode, RouteParamsList } from 'packages/route'
import React, { Suspense } from 'react'
import {
  Redirect,
  RedirectProps,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router-dom'

import { ModalRoute } from './ModalRoute'

/**
 * @deprecated use RouteComponent instead of React.FC<RouteProps>
 */
export type RouteProps<T = any> = {
  route: RouteNode
} & RouteComponentProps &
  T

type RouteCompProps<
  TRouteParamsList extends RouteParamsList,
  TProps = {}
> = TProps & {
  route: RouteNode & { name?: keyof TRouteParamsList }
}

export type RouteComponent<
  TRouteParamsList extends RouteParamsList,
  TProps = {}
> = React.FC<RouteCompProps<TRouteParamsList, TProps>>

/**
 * 路由组件
 *
 * @param props - 参数
 * @param props.routes - routes 数据
 * @param props.modalRoutes - modalRoutes 数据
 * @param props.redirect - 重定向 url
 * @param props.authFunction - 校验 auth 是否正确
 * @returns component
 */
export const NestedRoute = ({
  routes = [],
  modalRoutes = [],
  redirect = { to: '/404' },
  authFunction = () => true,
  ...params
}: {
  routes?: RouteNode[]
  modalRoutes?: ModalRouteNode[]
  redirect?: RedirectProps
  authFunction?: (route: RouteNode) => boolean
}) => (
  <>
    <Suspense fallback={null}>
      <Switch>
        {routes.map((route: RouteNode) => (
          <Route
            key={route.path}
            path={route.path}
            exact={route.exact}
            render={(props) =>
              authFunction(route) ? (
                <route.component
                  {...props}
                  route={route}
                  {...params}
                />
              ) : (
                <Redirect to="/403" />
              )
            }
          />
        ))}
        <Redirect {...redirect} />
      </Switch>
    </Suspense>
    <Suspense fallback={null}>
      {uniqBy(modalRoutes, 'name').map((route: ModalRouteNode) => (
        <ModalRoute
          key={route.name}
          route={route}
        />
      ))}
    </Suspense>
  </>
)
